import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

export enum ErrorType {
    NotFound = "404",
    NoAccess = "no-access",
}

interface ErrorConfig {
    image: {
        light: string;
        dark: string;
    };
    title: string;
    message: string;
    buttonText?: string;
    buttonAction?: () => void;
}

@Component({
    templateUrl: "no-content.component.html",
    styleUrls: ["./no-content.component.scss"],
})
export class NoContentComponent implements OnInit {
    errorConfig: ErrorConfig;
    errorType: ErrorType = ErrorType.NotFound;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
    ) {}

    ngOnInit() {
        const errorTypeParam =
            this.activatedRoute.snapshot.queryParams["errorType"] ||
            this.activatedRoute.snapshot.data["errorType"];

        if (errorTypeParam) {
            this.errorType = errorTypeParam as ErrorType;
        }

        const customMessage =
            this.activatedRoute.snapshot.queryParams["message"];

        this.errorConfig = this.getErrorConfig(this.errorType, customMessage);
    }

    private getErrorConfig(
        type: ErrorType,
        customMessage?: string,
    ): ErrorConfig {
        const configs: Record<ErrorType, ErrorConfig> = {
            [ErrorType.NotFound]: {
                image: {
                    light: "/assets/img/404-Error.svg",
                    dark: "/assets/img/404-Error.svg",
                },
                title: "Captain, check the instruments! It appears we've gone off course.",
                message:
                    customMessage ||
                    "The page you are attempting to locate does not seem to exist. Turn this aircraft around.",
                buttonText: "Go Back Home",
                buttonAction: () => this.router.navigateByUrl("/"),
            },
            [ErrorType.NoAccess]: {
                image: {
                    light: "/assets/img/illustration_need-access.svg",
                    dark: "/assets/img/illustration_need-access-dark.svg",
                },
                title: "Access Restricted",
                message: customMessage
                    ? customMessage +
                      " Please contact your administrator if you believe this is an error."
                    : "You don't have permission to access this resource. Please contact your administrator if you believe this is an error.",
                buttonText: "Go Back Home",
                buttonAction: () => this.router.navigateByUrl("/"),
            },
        };

        return configs[type] || configs[ErrorType.NotFound];
    }

    flights() {
        if (this.errorConfig.buttonAction) {
            this.errorConfig.buttonAction();
        } else {
            this.router.navigateByUrl("/");
        }
    }
}
